import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import firebase from './config/fbConfig';
import './App.scss'
import Login from './components/Auth/Login/Login';
import Register from './components/Auth/Register/Register';
import Navbar from './components/Navbar/Navbar';
import Dashboard from './pages/Dashboard/Dashboard';
import Guide1 from './pages/Guide/Guide1';
import Guide2 from './pages/Guide/Guide2';
import Home from './pages/Home/Home';
import Modality from './pages/Modality/Modality';
import Preferences from './pages/Preferences/Preferences';
import Profile from './pages/Profile/Profile';
import AvailablePlans from './pages/AvailablePlans/AvailablePlans';
import Privacity from './pages/Privacity/Privacity';
import Contact from './pages/Contact/Contact';
import RecoverPassword from './components/Auth/RecoverPassword/RecoverPassword';
import Wallet from './pages/Wallet/Wallet';
import Privacy from './pages/Privacy/Privacy';

function App() {

  const [login, setLogin] = useState(null)

  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        
        setLogin(user.uid)

      }else {
        setLogin(null)
      }
    })
    console.log(login)

  }, [login])

  console.log(login)

  return (
    <div className="app">
      <Router>
        <Navbar />

        {
          login ?
          <>
            <Switch>
              <Route path='/choose/preferences' component={Preferences} />
              <Route path='/profile' component={Profile} />
              <Route path='/privacity' component={Privacy} />
              <Route path='/signin' component={Login} />
              <Route path='/contact' component={Contact} />
              <Route path='/wallet' component={Wallet} />
              <Route path='/plans' component={AvailablePlans} />
              <Route path='/' component={Dashboard} />
            </Switch>
          </> :
            <Switch>
              <Route path='/recover_password' component={RecoverPassword} />
              <Route path='/guide/final' component={Guide2} />
              <Route path='/signin' component={Login} />
              <Route path='/signup' component={Register} />
              <Route path='/guide' component={Guide1} />
              <Route path='/' component={Home}/>
            </Switch>
        }

        
      </Router>

      <ToastContainer 
          position="top-right"
          autoClose={4000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover />
    </div>
  );
}



export default App;
